import React from 'react';
import YoutubePlayer from '../../common/YoutubePlayer';
import CloseModalButton from '../../common/Modal/Buttons/CloseModalButton';

export default function Modal(props) {
	return (
		<div className='project-popup '>
			<h1 className='project-popup__title '>Canvas snake game</h1>
			<p className='project-popup__description '>
				The simple game is created using Canvas.js. It's mobile-friendly.
				<br /> P.S Don't try to collect 14 apples; the game contains a screamer ;)
			</p>
			<div className='project-popup__about '>
				<p>
					<span className='span-title '>Stack:</span>
					<span className='span-description '>Javascript, Canvas.js</span>
				</p>
			</div>
			<div className='project-popup__videos'>
				<YoutubePlayer
					src='https://www.youtube.com/embed/q38tV5ZfgM8'
					title='Canvas snake game'
				/>
			</div>
			<div className='project-popup__buttons '>
				<a
					href='https://slava-nik.github.io/snakeGame'
					className='project-link '
					target='_blank'
					rel='noopener noreferrer'
				>
					Visit project
				</a>
				<CloseModalButton onClose={props.closeModal} />
			</div>
		</div>
	);
}
